export class CompanyCompensationComplianceApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getConfig({ companyId }) {
    // DEV-3647: a TPO broker (sub-company user) cannot read the parent company's compliance config and
    // gets a 403 here. The Company Manager Compensation tab degrades gracefully to the default change
    // window when this is absent, so skip the forbidden interceptor to avoid the page-reload behavior.
    return this.#http.get(`/api/companies/${companyId}/compensation-compliance-config`, {
      skipResponseInterceptor: { forbiddenError: true },
    });
  }

  async updateConfig({ companyId, modificationLeadDays, periodPolicy }) {
    return this.#http.put(`/api/companies/${companyId}/compensation-compliance-config`, {
      modificationLeadDays,
      periodPolicy,
    });
  }
}
